import { Button, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { CustomTable, SearchTableInput } from "../../../components";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import { puserTableHeading } from "../../../assets/lib/puser";
import { useMediaQuery } from '@mui/material';

const customStyle = makeStyles({
  root: {
    padding: "20px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    overflow: "hidden",
  },
  buttonContainer: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
  },
  actionBtn: {
    display: "flex",
    gap: "30px",
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "5px 5px",
      width: "80%",
      display: "flex",
      flexDirection: "column",
      gap: "40px",
      overflow: "hidden",
    },
    buttonContainer: {
      height: "50px",
      display: "flex",
      justifyContent: "start",
      flexWrap:"wrap",
      gap: "10px",

    },
    actionBtn: {
      display: "flex",
      gap: "10px",
    },
  },
});

const Layout = (props) => {
  const {
    userTableData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
  } = props;

  const classes = customStyle();
  const navigate = useNavigate();
  const isPhone = useMediaQuery('(max-width: 390px)');

  const actions = [
    {
      label: "View",
      onClick: (row) => {
        navigate(`${routes.PUSER_INFO}/${row.id}`, {
          state: { add: false, edit: false },
        });
      },
      bgColor: "#2196F3",
      
    },
    {
      label: "Edit",
      onClick: (row) => {
        navigate(`${routes.PUSER_INFO}/${row.id}`, {
          state: { add: false, edit: true },
        });
      },
      bgColor: "#4CAF50",
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.buttonContainer}>
        <SearchTableInput
          tableHeading={puserTableHeading}
          handleSearchQuery={handleSearchQuery}
        />
        <div className={classes.actionBtn}>
          <Button
            variant="contained"
            style={{ textTransform: 'none' ,borderRadius:"6px",fontFamily: 'Inter, sans-serif',backgroundColor:"#8b003c",color:"white",'&:hover': {
              backgroundColor: '#8b003c', // keep background same
              color: 'white',    
              '&:hover': {
                backgroundColor: '#8b003c', // keep background same
                color: 'white',             // prevent text turning blue
              },         // prevent text turning blue
            },}} 
            onClick={() =>
              navigate(routes.PUSER_INFO, {
                state: { add: true, edit: false },
              })
            }
          >
            Add User
          </Button>
        </div>
      </div>
      <CustomTable
        columns={puserTableHeading}
        data={userTableData}
        actions={actions}
        isLoading={isTableLoading}
        currentPage={currentPage}
        totalLength={totalLength}
        handlePageChange={handlePageChange}
        handlePageSize={handlePageSize}
        handleTableSorting={handleTableSorting}
      />
    </div>
  );
};

export default Layout;
